import { NavLink } from "react-router-dom";  
import { cn } from "../../lib/utils";  
import React, { useState, useEffect } from "react";  

// Define the User type  
interface User {  
    id: number; // or string depending on your ID type  
    emailId: string;  
    role: string;  
    status?: string; // Optional property if it can be absent  
}  

// Define the props for the EditableUserSelect component  
interface EditableUserSelectProps {  
    users: User[];  
    onSelectUser: (user: User | null) => void;  
    selectedUserRole?: string | null;  
    selectedUserID?: number | null; // or string depending on your ID type
    filteredUsersData? :User[];  
    onFilterDataChanged:(users :User[]| null)=>void ;
}  

const EditableUserSelect: React.FC<EditableUserSelectProps> = React.memo(({   
    users,   
    onSelectUser,   
    selectedUserRole,   
    selectedUserID,
    filteredUsersData,
    onFilterDataChanged
}) => {  
    const [email, setEmail] = useState<string>('');  
    const [filteredUsers, setFilteredUsers] = useState<User[]>(filteredUsersData);  
    const [selectedRole, setSelectedRole] = useState<string | null>(selectedUserRole ?? null);  
    const [selectedUserId, setSelectedUserId] = useState<number | null>(selectedUserID ?? null);  

    // Filter users based on email input  
    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {  
        const inputValue = e?.target?.value;  
        setEmail(inputValue);  
        onSelectUser(null); // Clear selected user  
        setFilteredUsers([]); // Clear existing filtered users  

        if (!!inputValue && inputValue.length>0) {  
            // Filter users based on the entered email  
            const filtered = users?.filter(user =>  
                user?.emailId?.toLowerCase().includes(inputValue?.toLowerCase())  
            );  
            setFilteredUsers(filtered);  
            setSelectedRole(filtered[0]?.role || null);  
            onFilterDataChanged(filtered);
        }  
    };  

    const handleRoleClick = (role: string) => {  
        setSelectedRole(role);  
    };  

    // Effect to update filtered users based on initial users list  
    useEffect(() => {  
        //setFilteredUsers(users);  
    }, [users]);  

    // Effect to update selected user role and ID when prop changes  
    useEffect(() => {  
        setSelectedRole(selectedUserRole);  
        setSelectedUserId(selectedUserID);  
    }, [selectedUserRole, selectedUserID]);  

    return (  
        <div className="space-y-4">  
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">Enter User Email</label>  
            <input  
                id="email"  
                type="email"  
                placeholder="Type user email..."  
                value={email}  
                onChange={handleEmailChange}  
                className="w-full border border-gray-300 rounded-md p-3 shadow-sm transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"  
            />  
            {selectedRole && (  
                <div className="flex space-x-2">  
                    <span  
                        key={selectedRole}  
                        onClick={() => handleRoleClick(selectedRole)}  
                        className={`cursor-pointer font-bold text-xs px-4 py-1 rounded-full   
                        ${selectedRole === "ADMIN" ? 'bg-yellow-200 text-brown-600 border-yellow-400'  
                            : selectedRole === "STUDENT" ? 'bg-gray-200 text-gray-600 border-gray-400'  
                            : selectedRole === "SUPERADMIN" ? 'bg-green-200 text-green-600 border-green-400'  
                            : 'bg-blue-200 text-blue-600 border-blue-400'}`}  
                    >  
                        {selectedRole}  
                    </span>  
                </div>  
            )}  
            {filteredUsers.length > 0 && (  
                <div className="border border-gray-300 rounded-md p-3 shadow-sm">  
                    <h3 className="text-sm font-medium text-gray-900 p-2">Select User:</h3>  
                    <ul>  
                        {filteredUsers.map(user => (  
                            <li key={user.id}>  
                                <NavLink  
                                    to="#"  
                                    className={({ isActive }) => cn(  
                                        "flex items-center justify-between p-2 cursor-pointer",  
                                        selectedUserId === user.id ? "bg-[#0071bd] text-white" : "hover:bg-gray-100"  
                                    )}  
                                    onClick={() => {  
                                        if (selectedUserId === user.id) {  
                                            onSelectUser(null);  
                                            setSelectedUserId(null);  
                                            setEmail('');  
                                        } else {  
                                            onSelectUser(user);  
                                            setSelectedUserId(user.id);  
                                            setEmail(user.emailId);  
                                        }  
                                    }}  
                                >  
                                    <span className="font-semibold">{user.emailId}</span>  
                                    <span className="font-semibold">{user.role}</span>  
                                </NavLink>  
                            </li>  
                        ))}  
                    </ul>  
                </div>  
            )}  
        </div>  
    );  
});  

export default EditableUserSelect;  